import { Component, OnInit } from '@angular/core';
import { Validations } from '../../../../class/workflow.type';
import { getValidationObject } from '../../../../helper/validation-converter/validation-converter';
import { CoreBuildingBlockControlBaseComponent } from '../../shared/building-block-control-base.component';
import { CoreBuildingBlock } from '../../shared/building-block.decorator';

@CoreBuildingBlock('textarea')
@Component({
  selector: 'cu-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss']
})
export class TextareaComponent extends CoreBuildingBlockControlBaseComponent implements OnInit {
  /** TextArea value */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public textAreaValue: any;
  /** Max character that will be allowed */
  public maxCharacterCount = 4000;
  /** remaining text count */
  public totalTextCount = 0;

  public screenReaderMessage = '';
  public isFocused = false;
  private timeout;

  public ngOnInit(): void {
    this.textAreaValue = this.field?.data ? this.field.data.value : '';
    this.countChar();
    const validations: Validations = getValidationObject(this.field);
    this.maxCharacterCount = validations.maxLength ? validations.maxLength : this.maxCharacterCount;
    this.setMesssage();
    super.ngOnInit();
  }

  public countChar(): void {
    this.totalTextCount = this.textAreaValue ? this.textAreaValue.length : 0;
    this.setMesssage();
  }

  private setMesssage() {
    if (this.timeout) clearTimeout(this.timeout);
    this.screenReaderMessage = `Filled ${this.totalTextCount} of ${this.maxCharacterCount} characters for ${this.field.label}}`;
    this.timeout = setTimeout(() => {
      this.screenReaderMessage = '';
    }, 0);
  }

  public onBlur(event): void {
    this.field.data.value = event.target.value;
    this.isFocused = false;
  }

  onFocus() {
    this.isFocused = true;
  }
}
